import React from 'react'; 
import numeral from 'numeral';

function Formata({formato,children}) {
    return <span>{numeral(children).format(formato)}</span>
}

export default Formata;
//http://numeraljs.com/